import './index.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactJoyride, { ACTIONS, EVENTS } from 'react-joyride';
import { toggleIntro } from '../../app/reducer';
import Modal from './Modal';
import CommonModal from './CommonModal';
import { I18n } from 'react-redux-i18n';
import Tut2 from '../../../assets/images/tutorial/tut-2.png';
import Tut3 from '../../../assets/images/tutorial/tut-3.png';
import Tut4 from '../../../assets/images/tutorial/tut-4.png';
import Tut5 from '../../../assets/images/tutorial/tut-5.png';
import Tut6 from '../../../assets/images/tutorial/tut-6.png';
import Tut7 from '../../../assets/images/tutorial/tut-7.png';
import Tut8_1 from '../../../assets/images/tutorial/tut-8-1.png';
import Tut8_2 from '../../../assets/images/tutorial/tut-8-2.png';

class IntroModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      run: false,
      steps: [
        {
          id: 0,
          title: 'demo',
          content: 'demo',
          target: '.demo-tutorial',
          placement: 'auto',
        },
        {
          id: 1,
          title: I18n.t('tutorial.tutorialContent.tut2.title'),
          content: I18n.t('tutorial.tutorialContent.tut2.message'),
          target: '#menu-tutorial',
          placement: 'auto',
          imgSrc: [Tut2],
          imgHeight: 231,
          imgWidth: 412,
        },
        {
          id: 2,
          title: I18n.t('tutorial.tutorialContent.tut3.title'),
          content: I18n.t('tutorial.tutorialContent.tut3.message'),
          target: '#workspace-tutorial',
          placement: 'auto',
          imgSrc: [Tut3],
          imgHeight: 233,
          imgWidth: 412,
        },
        {
          id: 3,
          title: I18n.t('tutorial.tutorialContent.tut4.title'),
          content: I18n.t('tutorial.tutorialContent.tut4.message'),
          target: '#setting-tutorial',
          placement: 'auto',
          imgSrc: [Tut4],
          imgHeight: 234,
          imgWidth: 412,
        },
        {
          id: 4,
          title: I18n.t('tutorial.tutorialContent.tut5.title'),
          content: I18n.t('tutorial.tutorialContent.tut5.message'),
          target: '#quick-component-tutorial',
          placement: 'auto',
          imgSrc: [Tut5],
          imgHeight: 233,
          imgWidth: 412,
        },
        {
          id: 5,
          title: I18n.t('tutorial.tutorialContent.tut6.title'),
          content: I18n.t('tutorial.tutorialContent.tut6.message'),
          target: '#search-box-tutorial',
          placement: 'auto',
          imgSrc: [Tut6],
          imgHeight: 232,
          imgWidth: 412,
        },
        {
          id: 6,
          title: I18n.t('tutorial.tutorialContent.tut7.title'),
          content: I18n.t('tutorial.tutorialContent.tut7.message'),
          target: '#language-tutorial',
          placement: 'bottom-start,',
          imgSrc: [Tut7],
          imgHeight: 232,
          imgWidth: 412,
        },
        {
          id: 7,
          title: I18n.t('tutorial.tutorialContent.tut8.title'),
          content: I18n.t('tutorial.tutorialContent.tut8.message'),
          target: '#theme-tutorial',
          placement: 'bottom-start,',
          imgSrc: [Tut8_1, Tut8_2],
          imgHeight: 112,
          imgWidth: 206,
        },
      ],
      stepIndex: 1, // a controlled tour
    };
  }

  componentWillReceiveProps(nextProps) {
    const { toggleIntro, firstTime } = this.props;

    if (firstTime !== nextProps.firstTime && nextProps.firstTime) {
      // if (!(firstTime !== nextProps.firstTime && nextProps.firstTime)) {
      // code check at client
      toggleIntro(true);
    }
  }

  handleStartIntro = e => {
    e.preventDefault();
    const { toggleIntro } = this.props;
    this.setState({ run: true });
    toggleIntro(false);
  };

  handleSkipIntro = () => {
    const { toggleIntro } = this.props;
    this.setState({ run: false, stepIndex: 1 });
    toggleIntro(false);
  };

  handleJoyrideCallback = data => {
    const { joyride } = this.props;
    const { action, index, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      // Update state to advance the tour
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    }

    if (type === EVENTS.TOUR_END && this.state.run) {
      // Need to set our running state to false, so we can restart if we click start again.
      this.setState({ run: false, stepIndex: 1 });
    }

    if (typeof joyride.callback === 'function') {
      joyride.callback(data);
    }
  };

  render() {
    const { isShowIntro } = this.props;
    const { run, steps, stepIndex } = this.state;
    let imgSrc = '';
    if (stepIndex < steps.length) {
      imgSrc = this.state.steps[stepIndex].imgSrc;
    }
    const defaultOptions = {
      arrowColor: '#273040',
      backgroundColor: '#fff',
      beaconSize: 36,
      overlayColor: 'rgba(0, 0, 0, 0.5)',
      primaryColor: '#f04',
      spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
      textColor: '#333',
      width: undefined,
    };
    return (
      <div className="joyride-overwrite-css">
        <ReactJoyride
          continuous
          disableCloseOnEsc={true}
          disableOverlayClose={true}
          stepIndex={stepIndex}
          run={run}
          steps={steps}
          styles={{
            options: {
              zIndex: 10000,
              ...defaultOptions,
            },
          }}
          tooltipComponent={props => (
            <CommonModal
              {...props}
              imgSrc={imgSrc}
              onSkip={this.handleSkipIntro}
            />
          )}
          callback={this.handleJoyrideCallback}
        />

        {isShowIntro && (
          <div className="intro-modal-wrapper">
            <Modal handleStartIntro={this.handleStartIntro} />
          </div>
        )}
      </div>
    );
  }
}

IntroModal.propTypes = {
  joyride: PropTypes.shape({
    callback: PropTypes.func,
  }),
};

IntroModal.defaultProps = {
  joyride: {},
};

const mapDispatchToProps = {
  toggleIntro,
};

const mapStateToProps = state => {
  return {
    isShowIntro: state.isShowIntro,
    firstTime: state['MAIN_LAYOUT:SIDEBAR:'].settingSystem.dataSystem.firstTime,
    // get user setting
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IntroModal);
